import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=597ce1ea&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ce1ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('597ce1ea')) {
      api.createRecord('597ce1ea', component.options)
    } else {
      api.reload('597ce1ea', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=597ce1ea&scoped=true&", function () {
      api.rerender('597ce1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8FVD0SYIMdlqC/JS/comp/Accordion.vue"
export default component.exports